<template>
  <div class="container">
    <div class="pc" id="mainIndex" v-if="screenWidth>=1200">
      <!--header-->
      <header-common :showRegister="showRegister"></header-common>
      <!-- 主页面容器 -->
      <div class="switch-container" :style="switchStyle">
        <!-- section    单个页面 -->
        <firstPage :showIndex="showIndex"></firstPage>
        <secondPage :showIndex="showIndex" :infoServiceList="infoServiceList"></secondPage>
        <thirdPage :showIndex="showIndex" :workList="workList"></thirdPage>
        <fourthPage :showIndex="showIndex" @toTop="backToTop" :fourthPageInfo="fourthPageInfo"></fourthPage>
      </div>
      <div class="index-box" :class="{first:showIndex==0}">
        <div
          v-for="(item,index) in 4"
          :key="'index'+index"
          :class="{chosen:index==showIndex}"
          @click="jumpTo(index)"
        >
          <span></span>
        </div>
      </div>
        <right-action :isShowTopBtn="isShowTopBtn" @backToTop="jumpTo(0)"></right-action>
    </div>
    <div class="web" v-else>
      <phone-page :infoServiceList="infoServiceList" :workList="workList" :fourthPageInfo="fourthPageInfo"></phone-page>
    </div>
  </div>
</template>

<script>
import headerCommon from './common/headerCommon';
import firstPage from "./homePage/firstPage";
import secondPage from "./homePage/secondPage";
import thirdPage from "./homePage/thirdPage";
import fourthPage from "./homePage/fourthPage";
import phonePage from "./phone/page";
import rightAction from './common/rightIcon';
export default {
    name: "index",
    data() {
        return {
            showRegister: true,
            showContact:false,
            isShowTopBtn: false,
            contact:{
                normal:require("../assets/images/page3/contact.png"),
                hover:require("../assets/images/page3/contact_hover.png")
            },
            showIndex: 0,
            switchStyle: {
                top: 0,
                left: 0
            },
            canScroll: true,
            infoServiceList: [
                {
                    pageId: 3,
                    imgurl: require("../assets/images/page2/gzjhhmb.png"),
                    title: "工作计划和目标",
                    subtitle: "",
                    content: "设定目标、确定计划、分解任务，甘特图直观显示，便于跟踪完成情况。"
                },
                {
                    pageId: 4,
                    imgurl: require("../assets/images/page2/xmgl.png"),
                    title: "项目管理",
                    subtitle: "",
                    content: "覆盖全生命周期，丰富的阶段模板和灵活的自定义，适用于各类项目的建设，保证项目建设有序进行。"
                },
                {
                    pageId: 2,
                    imgurl: require("../assets/images/page2/bxfw.png"),
                    title: "报修服务",
                    subtitle: "",
                    content: "多种报修方式：电话、PC端、APP端、微信小程序。来电弹屏建单、录音自动开启。智能报修知识库、报修单自动关联，报修统计分析。"
                },

                {
                    pageId: 5,
                    imgurl: require("../assets/images/page2/xqgl.png"),
                    title: "需求管理",
                    subtitle: "",
                    content: "对用户需求进行管理，从审批、开发、测试、上线到反馈，都在系统上呈现，输出物直接上传，可随时查询进度。"
                },
                {
                    pageId: 6,
                    imgurl: require("../assets/images/page2/rwd.png"),
                    title: "任务单",
                    subtitle: "",
                    content: "是日常工作的最小单元，定义目标、负责人、时间节点等信息，进展实时更新查看。"
                },
                {
                    pageId: 7,
                    imgurl: require("../assets/images/page2/ywxj.png"),
                    title: "运维巡检",
                    subtitle: "",
                    content: "巡检任务自定义（机房/设备/参数/检测项等），按需上传巡检报告，也可指派给第三方。"
                },
                {
                    pageId: 9,
                    imgurl: require("../assets/images/page2/dzbl.png"),
                    title: "电子病历评级",
                    subtitle: "",
                    // subtitle: "限时免费开放",
                    content: "辅助用户完成电子病历评级工作。数据填写过程中自动评分，实时显示。评级任务逐项分解，高效协作。实证材料一键导出，直接上报。"
                },
                {
                    pageId: 8,
                    imgurl: require("../assets/images/page2/djyyps.png"),
                    title: "等级医院评审",
                    subtitle: "",
                    content: " 将评审工作紧密结合日常工作，电子台账自动生成。评审任务逐项分解，责任划分明确。"
                },
                {
                    pageId: 11,
                    imgurl: require("../assets/images/page2/gzhb.png"),
                    title: "工作汇报",
                    subtitle: "",
                    content: "包含日报、周报、月报、值班、交接班等。可关联需求单、任务单、报修单、会议等，一键添加，无需重复录入。"
                },
                {
                    pageId: 10,
                    imgurl: require("../assets/images/page2/htgl.png"),
                    title: "合同管理",
                    subtitle: "",
                    content: "管理合同的基本信息和付款信息（可上传合同附件）。付款计划直观显示，已付款项可上传发票。"
                },
                {
                    pageId: 18,
                    imgurl: require("../assets/images/page2/zsk.png"),
                    title: "知识库",
                    subtitle: "",
                    content: "灵活定义目录结构和权限，保存历史修改的各个版本，可关键字检索，方便查询。"
                },
                {
                    pageId: 1,
                    imgurl: require("../assets/images/page2/rcgz.png"),
                    title: "日常工作",
                    subtitle: "",
                    content: "考勤管理、值班/排班管理、请休假管理、会议管理，让管理更全面。"
                }
            ],
            workList: [
                {
                    normalurl: require("../assets/images/page3/icon_app.png"),
                    activeurl: require("../assets/images/page3/icon_app_active.png"),
                    title: "APP:",
                    content:
                        "仅需一部手机即可随时掌握工作进度，任务、报修、资料、日志等等，应有尽有。"
                },
                {
                    normalurl: require("../assets/images/page3/icon_application.png"),
                    activeurl: require("../assets/images/page3/icon_application_active.png"),
                    title: "小程序:",
                    content:
                        "无需下载安装，就可以通过微信快速报修，支持评价、催办，节省人力，提高效率。"
                },
                {
                    normalurl: require("../assets/images/page3/icon_wechat.png"),
                    activeurl: require("../assets/images/page3/icon_wechat_active.png"),
                    title: "企业微信:",
                    content:
                        "1分钟快速录入合同，收支计划一目了然，收付款自动提醒，线上管理发票收据，随时随地掌握合同执行情况。"
                }
            ],
            fourthPageInfo: {
                itemList: [
                    {
                        imgurl: require("../assets/images/page4/qsmzqgl.png"),
                        title: "全生命周期管理，强化质控",
                        content:
                            "全生命周期管理。对工作进行科学管理，持续检查与改进，循环往复。",
                        align: "left"
                    },
                    {
                        imgurl: require("../assets/images/page4/gzkshgl.png"),
                        title: "工作可视化管理，一目了然",
                        content:
                            "总览全局，对工作进行综合管理，排定工作优先级，实时跟踪工作进展，及时发现解决问题。",
                        align: "right"
                    },
                    {
                        imgurl: require("../assets/images/page4/mbjhgl.png"),
                        title: "目标计划管理，掌控进度",
                        content:
                            "工作事项分解部署，分配到人。重点事项重点关注，提高执行力。管理者实时掌控任务进度和完成情况。",
                        align: "left"
                    },
                    {
                        imgurl: require("../assets/images/page4/xtgl.png"),
                        title: "协同管理，信息更高效",
                        content:
                            "对内加强信息交互、协同配合，及时反馈；对外强化第三方管理，在平台上接收需求、完成任务并反馈。",
                        align: "right"
                    },

                    {
                        imgurl: require("../assets/images/page4/gzlh.png"),
                        title: "工作留痕，传承经验",
                        content:
                            "工作以需求单、任务单、问题单、会议等形式体现，并通过文字、照片、视频等形成完整记录，供参考和借鉴。",
                        align: "left"
                    },
                    {
                        imgurl: require("../assets/images/page4/qbsjaq.png"),
                        title: "四大举措，确保数据安全",
                        content:
                            "传输加密、存储加密、数据备份、访问权限、保证数据可用性、完整性、机密性。",
                        align: "right"
                    },
                    {
                        imgurl: require("../assets/images/page4/zyzh.png"),
                        title: "五大模块，自由组合",
                        content: "系统采用模块化设计，可随意结合，自由定制，满足个性化需求。",
                        align: "left"
                    },
                    {
                        imgurl: require("../assets/images/page4/xxgl.png"),
                        title: "信息管理，遵循规范",
                        content:
                            "根据PDCA、ITSS和ITIL理念紧密结合医院实践，全面保障信息系统高效运行。",
                        align: "right"
                    }
                ]
            },
            screenWidth: 0
        };
    },
    components: {
        headerCommon,
        firstPage,
        secondPage,
        thirdPage,
        fourthPage,
        phonePage,
        rightAction
    },
    methods: {
        bindWheel() {
            let that = this;
            window.addEventListener("mousewheel", function(e) {
                if (that.canScroll) {
                    if (e.wheelDelta < 0) {
                        if (that.showIndex !== 3) {
                            that.showIndex = that.showIndex + 1;
                        }
                        that.switchStyle.top = "-" + that.showIndex + "00%";
                    } else {
                        if (that.showIndex !== 0) {
                            that.showIndex = that.showIndex - 1;
                        }
                        that.switchStyle.top = "-" + that.showIndex + "00%";
                    }
                    if (that.showIndex !== 0) {
                        that.isShowTopBtn = true;
                    } else {
                        that.isShowTopBtn = false;
                    }
                    that.canScroll = false;
                    setTimeout(function() {
                        that.canScroll = true;
                    }, 1500);
                }
            });

            window.addEventListener("DOMMouseScroll",function(e) {
                /*火狐*/
                if (that.canScroll) {
                    if (e.detail > 0) {
                        if (that.showIndex !== 3) {
                            that.showIndex = that.showIndex + 1;
                        }
                        that.switchStyle.top = "-" + that.showIndex + "00%";
                    } else {
                        if (that.showIndex !== 0) {
                            that.showIndex = that.showIndex - 1;
                        }
                        that.switchStyle.top = "-" + that.showIndex + "00%";
                    }
                    if (that.showIndex !== 0) {
                        that.isShowTopBtn = true;
                    } else {
                        that.isShowTopBtn = false;
                    }
                    that.canScroll = false;
                    setTimeout(function() {
                        that.canScroll = true;
                    }, 1500);
                }
            },false);
        },
        scrollPage(){

        },
        jumpTo(index) {
            this.showIndex = index;
            this.switchStyle.top = "-" + this.showIndex + "00%";
            if (index !== 0) {
                this.isShowTopBtn = true;
            } else {
                this.isShowTopBtn = false;
            }
            // console.log( this.switchStyle.top);
        },
        backToTop() {
            this.jumpTo(0);
        },
        register(){
            this.$router.push({path:"/registerPage"});
        }
    },
    mounted() {
        this.bindWheel();
        let that = this;
        this.$nextTick(()=> {
            that.screenWidth = window.screen.width;
        });
        $(window).bind('resize',function () {
            that.screenWidth = window.screen.width;
        });
    }
};
</script>

<style scoped>
.container {
  height: 100%;
  width:100%;
  position: relative;
}
.container .pc{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.container .web{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.btn{
  width:80px;
  height:32px;
  border-radius:5px;
  margin-left:10px;
  font-size:16px;
  line-height:32px;
  box-sizing: border-box;
}

.btn.login{
  color:#fff;
  background-color: #fff;
  background-color: #00a0e9;
}

.btn.login:hover{
  background-color: #4a97bb;
}

.btn.register{
  color:#5a5657;
  border:1px solid #b4b4b4;
}

.btn.register:hover{
  background-color: rgb(240, 233, 233);
}

/* 主体页面部分 */

/* 主体容器 */

.switch-container {
  height: 400%;
  width: 100%;
  position: absolute;
  transition: all 0.5s ease-in;
}

/* 单个页面样式 */
.section {
  height: 25%;
  width: 100%;
  position: relative;
}

.pointer {
  cursor: pointer;
}

/* 右侧滚动原点 */
.index-box {
  position: fixed;
  /* display: flex; */
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.index-box div {
  width: 20px;
  height: 20px;
  margin: 11px 0;
  cursor: pointer;
}
.index-box div span {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #a6a6a6;
  border-radius: 50%;
  transition: all 0.3s linear;
}
.index-box div.chosen span {
  border: 2px solid #157eff;
  background-color: transparent;
  width: 17px;
  height: 17px;
  box-sizing: border-box;
}

.index-box.first div span {
  background-color: #ffffff;
}

.index-box.first div.chosen span {
  border: 2px solid #fff;
  background-color: transparent;
  /* width: 17px;
  height: 17px; */
}


.contact{
  position:fixed;
  bottom:80px;
  right:28px;
  cursor: pointer;
}
.contact-box{
  width:272px;
  height:144px;
  position:absolute;
  top:0;
  right:0;
  transform: translateY(-100%);
  background:url(../assets/images/page3/bg_contact.png) center no-repeat;
  background-size:100% 100%;
  padding-left:20px;
  padding-top:20px;
  box-sizing: border-box;
  color:#333;
  text-align: left;
}

.contact-box .contact-name{
  font-size:18px;
  font-weight:bold;
  margin-bottom:15px;
}

.contact-box .contact-way{
  font-size:14px;
  line-height:30px;
}

.contact-box .contact-way img{
  margin-right:10px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue